<template>
    <div class="content">
        <Row type="flex" align="middle" class="code-row-bg mb16">
            <Col span="24">
                <Breadcrumb>
                    <Breadcrumb-item to="/">首页</Breadcrumb-item>
                    <Breadcrumb-item to="/my/customizedCCIC/rider">我的保全</Breadcrumb-item>
                    <Breadcrumb-item>保全详情</Breadcrumb-item>
                </Breadcrumb>
            </Col>
        </Row>
        <!-- 订单基本信息 -->
        <orderBasicInfo class="mb16" :info="info" title="批单基本信息" type="rider" />
        <!-- 批单信息 -->
        <riderInfo :info="info" />
    </div>
    </template>
    <script>
    import orderBasicInfo from '../common/orderBasicInfo'
    import riderInfo from '../common/riderInfo'
    export default {
        components:{ 
            orderBasicInfo,
            riderInfo
        },
        data () {
            return {
                info:{},
                id:this.$route.params.id,
                loading:false,
            }
        },
        mounted () {
            this.getInfo();
        },
        methods:{
            /*企业雇主责任险获取批单信息*/
            getInfo () {
                this.$axios.get('/broker/insurance/endorse/detailByEndorseNo',{
                    endorseNo: this.id
                }).then(res=>{
                    this.info = res;
                });
            },
        }
    }
    </script>
<style lang="less" scoped>
    .content{
        width: 100%;
        height: 100%;
        padding: 15px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/rider/detail.vue